import type { SideBarKey } from './utils';

export const DEFAULT_SIDEBAR_TABS: { field_key: SideBarKey }[] = [
  { field_key: 'clive_chat' },
  { field_key: 'clive_insights' },
  { field_key: 'summary' },
  { field_key: 'conductor_hub' },
  { field_key: 'management' },
  { field_key: 'notes' },
  { field_key: 'legal_actions' },
  { field_key: 'finances' },
  { field_key: 'communications' },
  { field_key: 'contacts' },
  { field_key: 'documents' },
  { field_key: 'gallery' },
  { field_key: 'policy' },
  { field_key: 'related_claims' },
  { field_key: 'osha' },
  { field_key: 'notifications' },
  { field_key: 'milestones' },
];
